import React, { useState, useEffect, useRef } from 'react'
import Layout from 'Layout'
import './OpenaiDetail.scss'
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import * as plugins from "suneditor/src/plugins";
import { mixGetV1, mixPostV1 } from 'services/mixin'
import { saveAs } from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useParams } from 'react-router-dom';

type MySunEditorProps = {
  value?: string;
  onChange?: (content: string) => void;
};

const Openai: React.FC = () => {
  const {slug} = useParams()
  const [showBrand, setShowBrand] = useState(false);
  const [showGenerate, setShowGenerate] = useState(false);
  const [isShowModal, setShowModal] = useState(false);
  const [isDownloadable, setIsDownloadable] = useState(false);
  const [languages, setLanguages] = useState<string[]>([])
  const [creativityList, setCreativityList] = useState<string[]>([])
  const [toneList, setToneList] = useState<string[]>([])
  const [content1, setContent1] = useState('');
  const [generatedContent, setGeneratedContent] = useState<string>('');
  const [modelChatDetail, setModelChatDetail] = useState({})
  const [idModel, setIDModel] = useState(-1)



  const [selectedLang, setSelectedLang] = useState('')
  const [selectedCreativity, setSelectedCreativity] = useState('')
  const [selectedTone, setSelectedTone] = useState('')
  const [maximumLength, setMaximumLength] = useState<number>(1000);
  const [isLoading, setIsLoading] = useState(false);

  const [value, setValue] = useState<string>('');
  const onChange = (content: string) => {
    setValue(content);
  };
  // Chuyển Markdown nhẹ sang HTML (hỗ trợ ###, ####, **bold**, paragraph, newline -> <br>)
  function mdToHtml(md:any) {
    // Escape HTML để tránh XSS
    const escapeHtml = (str:any) =>
      str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");

    // Chia đoạn theo 2 hoặc nhiều dấu xuống dòng
    const blocks = md.split(/\n{2,}/);

    const htmlBlocks = blocks.map((block:any) => {
      let text = block.trim();

      // Heading ####
      if (text.startsWith("#### ")) {
        const content = escapeHtml(text.replace(/^####\s+/, ""));
        return `<h4>${content}</h4>`;
      }

      // Heading ###
      if (text.startsWith("### ")) {
        const content = escapeHtml(text.replace(/^###\s+/, ""));
        return `<h3>${content}</h3>`;
      }

      // Các đoạn thông thường -> <p>...</p>
      // Giữ xuống dòng đơn bằng <br>
      let escaped = escapeHtml(text)
        .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>") // bold
        .replace(/\n/g, "<br>"); // xuống dòng

      return `<p>${escaped}</p>`;
    });

    return htmlBlocks.join("<br>");
  }
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await mixGetV1('/api/v1/fe/other/setting')
        if (res?.data?.json) {
          const parsed = JSON.parse(res.data.json)

          if (parsed.language_chatgpt_content) {
            setLanguages(parsed.language_chatgpt_content)
            setSelectedLang(parsed.language_chatgpt_content[0])
          }
          if (parsed.creativity_chatgpt_content) {
            setCreativityList(parsed.creativity_chatgpt_content)
            setSelectedCreativity(parsed.creativity_chatgpt_content[0])
          }
          if (parsed.tone_of_voice_chatgpt_content) {
            setToneList(parsed.tone_of_voice_chatgpt_content)
            setSelectedTone(parsed.tone_of_voice_chatgpt_content[0])
          }
        }
      } catch (error) {
        console.error('Lỗi load settings:', error)
      }
    }

    fetchSettings()
  }, [])
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true); 

    try {
      const payload = {
        language: selectedLang,
        content: 0,
        maximum_length: maximumLength,
        creativity: selectedCreativity,
        tone_of_voice: selectedTone,
        group_id: 0,
        type :value,
        is_image: 0,
        company_name:content1,
        model_chat_id: idModel,
      };

      console.log("Gửi payload:", payload);

      const res = await mixPostV1("/api/v1/fe/chat", payload);

      if (res?.data?.mes) {
        console.log("Kết quả AI:", res.data.mes);
        const GreatContent = mdToHtml(res.data.mes)
        setGeneratedContent(GreatContent);
        setShowGenerate(true);
      }
    } catch (err) {
      console.error("Lỗi khi generate:", err);
    }
    finally {
      setIsLoading(false); // tắt loading dù thành công hay thất bại
    }
  };
  const handleDownload = async (type: string) => {
    if (!generatedContent) {
      alert("Không có nội dung để tải xuống!");
      return;
    }

    try {
      if (type === "doc") {
        // Tạo file Word
        const converted = htmlDocx.asBlob(generatedContent);
        saveAs(converted, "output.docx");
      } else if (type === "pdf") {
        // Tạo file PDF từ HTML
        const pdf = new jsPDF("p", "pt", "a4");
        const element = document.createElement("div");
        element.innerHTML = generatedContent;
        document.body.appendChild(element);

        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL("image/png");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("output.pdf");

        document.body.removeChild(element);
      } else if (type === "html") {
        // Tải file HTML
        const blob = new Blob([generatedContent], { type: "text/html;charset=utf-8" });
        saveAs(blob, "output.html");
      }
    } catch (err) {
      console.error("Lỗi khi tải file:", err);
    }
  };
  const getModelChatDetail = async (slug:any) => {
    try {
        const res = await mixGetV1(`/api/v1/fe/model_chat/${slug}`)

        if(res.status) {
            setModelChatDetail(res.data)
            setIDModel(res.data.id)
        }
    } catch (err) {
        console.log(err)
    }
  }

  useEffect(() => {
      getModelChatDetail(slug)
  }, [])
  return (
    <Layout>
      <div id="lqd-titlebar" className="lqd-titlebar pt-6 pb-7 border-b transition-colors">
        <div className="lqd-titlebar-container flex flex-wrap items-center justify-between gap-y-4 container">
          <div className="lqd-titlebar-col lqd-titlebar-col-nav group/titlebar-nav flex w-full flex-col gap-2 lg:w-7/12">
            <p className="lqd-titlebar-pretitle text-xs text-foreground/70 m-0">
              <a
                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent hover:underline hover:transform-none hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none text-inherit hover:text-foreground"
                href="/"
              >
                <svg stroke-width="1.5" className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M15 6l-6 6l6 6"></path>
                </svg>
                Back to dashboard
              </a>
            </p>
            <h1 className="lqd-titlebar-title m-0">
              {modelChatDetail?.name}
            </h1>
            <p className="lqd-titlebar-subtitle mt-1 text-2xs opacity-80 only:my-0 last:mb-0">
              {modelChatDetail?.content}
            </p>
          </div>

          {/* <div className="lqd-titlebar-col lqd-titlebar-col-actions group/titlebar-actions flex w-full flex-wrap gap-y-3 max-lg:has-[.max-lg\:hidden:only-child]:hidden lg:w-5/12 lg:justify-end">
            <div className="lqd-titlebar-actions flex flex-wrap items-center gap-2">
              <a
                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-md py-2 px-4 lqd-btn-hover-none mx-2"
                href="https://demo.magicproject.ai/dashboard/user/openai/documents/all"
              >
                My Documents
              </a>
              <a className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-md py-2 px-4 lqd-btn-hover-none" href="/">
                <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 5l0 14"></path>
                  <path d="M5 12l14 0"></path>
                </svg>
                New
              </a>
            </div>
          </div> */}
        </div >
      </div >
      <div className="lqd-page-content-container h-full container">
        <div className="py-10">
          <div className="lqd-generator-wrap grid grid-flow-row gap-y-8 lg:grid-flow-col lg:[grid-template-columns:41%_59%]" data-generator-type="text">
            <div className="flex w-full flex-col gap-6 lg:pe-14">
              <div className="lqd-card text-card-foreground bg-card-background w-full transition-all group/card lqd-card-outline border border-card-border rounded-card lqd-generator-remaining-credits">
                {/* <div className="lqd-card-body relative only:grow lqd-card-md py-5 px-7">
                  <h5 className="mb-3 text-xs font-normal">
                    Remaining Credits
                  </h5>

                  <div className="lqd-remaining-credit relative mx-2 flex flex-col gap-3 text-2xs pe-12">
                    <div className="lqd-remaining-credits-legends flex items-center justify-between gap-3 gap-y-1.5 flex-wrap">
                      <div className="lqd-legend flex items-center gap-2.5 group">
                        <span className="lqd-legend-sm size-2 lqd-legend-box shrink-0 grow-0 rounded-full bg-primary"></span>
                        <span className="lqd-legend-label">
                          Words
                        </span>
                        <span className="ms-auto font-medium"> Unlimited </span>
                      </div>

                      <div className="lqd-legend flex items-center gap-2.5 group">
                        <span className="lqd-legend-sm size-2 lqd-legend-box shrink-0 grow-0 rounded-full bg-secondary"></span>
                        <span className="lqd-legend-label">
                          Images
                        </span>
                        <span className="ms-auto font-medium"> Unlimited </span>
                      </div>
                    </div>
                    <div className="lqd-progress flex overflow-hidden rounded-full h-1">
                      <div className="lqd-progress-bar grow-0 basis-auto bg-primary shrink-1" style={{ width: '100%' }}></div>
                      <div className="lqd-progress-bar grow-0 basis-auto bg-secondary shrink-1" style={{ width: '100%' }}></div>
                    </div>

                    <div
                      className="lqd-modal lqd-modal-default static -mt-3"
                    >
                      <a
                        className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-outline outline -outline-offset-1 focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-secondary lqd-btn-md lqd-btn-hover-none absolute end-0 top-0 size-9 shrink-0 p-0 outline-heading-foreground/10 hover:bg-primary hover:text-primary-foreground"
                        title="View Your Credits"
                        href="#"
                        onClick={() => setShowModal(true)}
                      >
                        <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                          <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
                        </svg>
                      </a>
                      {isShowModal && (
                        <div className="lqd-modal-modal z-[999] flex items-center justify-center overflow-y-auto overscroll-contain fixed inset-0">
                          <div className="lqd-modal-backdrop fixed inset-0 bg-black/5 backdrop-blur-sm" onClick={() => setShowModal(false)}></div>

                          <div className="mw-715px lqd-modal-content relative z-[100] max-h-[95vh] min-w-[min(calc(100%-2rem),540px)] overflow-y-auto overscroll-contain rounded-xl bg-background shadow-2xl shadow-black/10">
                            <div className="lqd-modal-head flex flex-wrap items-center gap-3 border-b px-4 py-2 relative">
                              <h4 className="my-0">Your Credit List</h4>
                              <button onClick={() => setShowModal(false)} className="lqd-modal-close size-8 ms-auto inline-flex items-center justify-center rounded-lg transition-all hover:bg-foreground/20" type="button">
                                <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                  <path d="M18 6l-12 12"></path>
                                  <path d="M6 6l12 12"></path>
                                </svg>
                              </button>
                            </div>

                            <div className="lqd-modal-body p-10">
                              <div className="container p-0">
                                <h3 className="mb-2">Unlock your creativity with credits</h3>
                                <p className="mb-5">Each credit unlocks powerful AI tools and features designed to enhance your content creation.</p>

                                <div className="credit-list-partial" id="credit-list-partial-537656">
                                  <table className="mb-4 w-full table-auto border-collapse border">
                                    <thead>
                                      <tr className="bg-foreground/10">
                                        <th className="border p-2 text-start">Model</th>
                                        <th className="border p-2 text-end">Credits</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Images
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 top-full -translate-y-1 before:-bottom-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">sd3-turbo</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">unsplash</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">pexels</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">pixabay</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">dall-e-3</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-image-1</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">nano-banana</span>
                                                  <span className="text-end font-medium">89</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">nano-banana/edit</span>
                                                  <span className="text-end font-medium">100</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">flux-pro</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">flux-pro/kontext/max/multi</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">flux-pro/kontext/text-to-image</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">flux-pro/kontext</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">ideogram-v2</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">midjourney</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">black-forest-labs/FLUX.1-schnell</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          Unlimited
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Words
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 top-full -translate-y-1 before:-bottom-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4-turbo</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4-1106-preview</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4-0125-preview</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4o</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4o-search-preview</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4o-mini-search-preview</span>
                                                  <span className="text-end font-medium">1000000</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">o1-mini</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">o3-mini</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4o-realtime-preview-2024-12-17</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4.1-mini</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-4.1-nano</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">o4-mini</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-5</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-5-mini</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-5-nano</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gpt-5-chat-latest</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">text-embedding-3-small</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">gemini-2.5-pro</span>
                                                  <span className="text-end font-medium">99962</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">serper</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">perplexity/llama-3.1-sonar-small-128k-chat</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          Unlimited
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Characters
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 top-full -translate-y-1 before:-bottom-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">elevenlabs-voice-chatbot</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">isolator</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          Unlimited
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Minutes
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 top-full -translate-y-1 before:-bottom-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">elevenlabs-ai-music</span>
                                                  <span className="text-end font-medium">43</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          43
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Seconds
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">sora-2-pro</span>
                                                  <span className="text-end font-medium">16</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          16
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Image to Video
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">image-to-video</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">klingV21</span>
                                                  <span className="text-end font-medium">7</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">klingImage</span>
                                                  <span className="text-end font-medium">12</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          Unlimited
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Video
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">video-upscaler</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">cogvideox-5b/video-to-video</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">animatediff-v2v</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">fast-animatediff/turbo/video-to-video</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">ad-marketing-video</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">ad-marketing-video-topview</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">ai-clip-klap</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          Unlimited
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Text to Speech
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">elevenlabs</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">tts-1</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">tts-1-hd</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">music-01</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          Unlimited
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Speech to Text
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">whisper-1</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          Unlimited
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="flex justify-between border-b p-2">
                                          Text to Video
                                          <span
                                            className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                          >
                                            <span className="lqd-tooltip-icon opacity-40">
                                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                  stroke-width="0"
                                                  fill="currentColor"
                                                ></path>
                                              </svg>
                                            </span>
                                            <span
                                              className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                            >
                                              <div>
                                                <h5 className="font-semibold">Credits Details</h5>
                                                <hr className="my-3 border-heading-foreground/10" />

                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">veo2</span>
                                                  <span className="text-end font-medium">13</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">veed</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">veo3</span>
                                                  <span className="text-end font-medium">4</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">veo3-fast</span>
                                                  <span className="text-end font-medium">3</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">kling-video</span>
                                                  <span className="text-end font-medium">13</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">kling</span>
                                                  <span className="text-end font-medium">10</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">ad-marketing-video</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">ad-marketing-video-topview</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                                <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                  <span className="text-start">ai-clip-klap</span>
                                                  <span className="text-end font-medium">Unlimited</span>
                                                </div>
                                              </div>
                                            </span>
                                          </span>
                                        </td>
                                        <td className="border p-2 text-end">
                                          Unlimited
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <div className="mt-4 border-t pt-3 text-end">
                                  <a
                                    className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-outline outline outline-button-border -outline-offset-1 focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-secondary lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                                    href="#"
                                    onClick={() => setShowModal(false)}
                                  >
                                    Close
                                  </a>
                                  <a
                                    className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                                    href="https://demo.magicproject.ai/dashboard/user/payment"
                                  >
                                    Upgrade Plan
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div > */}
              </div >

              <div className="lqd-card text-card-foreground bg-card-background w-full transition-all group/card lqd-card-variant-none lqd-generator-options-card">
                <div className="lqd-card-body relative only:grow lqd-card-size-none">
                  <form  onSubmit={handleSubmit} className="lqd-generator-form flex flex-wrap justify-between space-y-5" id="openai_generator_form">
                    <div className="flex w-full flex-col gap-5 mb-0" x-data="{ 'brandEnabled': false }">
                      <div className="lqd-input-container relative">
                        {/* <label
                          className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label"
                          htmlFor="brand"
                        >
                          <input
                            id="brand"
                            className="lqd-input peer focus:ring focus:ring-secondary dark:focus:ring-foreground/10 lqd-input-switcher border-2 border-input-border [--input-rounded-multiplier:5] cursor-pointer appearance-none [background-size:1.3rem] bg-left bg-no-repeat transition-all checked:bg-right checked:bg-heading-foreground checked:border-heading-foreground dark:checked:bg-label dark:checked:border-label lqd-input-md w-12 h-6"
                            name="brand"
                            type="checkbox"
                            checked={showBrand}
                            onChange={(e) => setShowBrand(e.target.checked)}
                          />

                          <span className="lqd-input-label-txt">
                            Include Your Brand
                          </span>
                        </label> */}
                      </div>

                      {showBrand && (
                        <div className="w-full flex-col gap-5 flex">
                          <div className="lqd-input-container relative">
                            <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3">
                              <span className="lqd-input-label-txt">
                                Select Company
                              </span>

                              <span className="ms-auto">
                                <a
                                  className="inline-flex size-6 items-center justify-center rounded-lg bg-green-500/20 text-green-700 transition-all hover:scale-110 hover:bg-green-500 hover:text-green-100"
                                  href="https://demo.magicproject.ai/dashboard/user/brand/create"
                                >
                                  <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M12 5l0 14"></path>
                                    <path d="M5 12l14 0"></path>
                                  </svg>
                                </a>
                              </span>
                            </label>

                            <select
                              id="company"
                              className="cursor-pointer lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                              name="company"
                              value=""
                            >
                              <option value="">
                                Select Company
                              </option>
                            </select>
                          </div>

                          <div className="lqd-input-container relative">
                            <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3">
                              <span className="lqd-input-label-txt">
                                Select Product/Service
                              </span>
                            </label>

                            <select
                              id="product"
                              className="cursor-pointer lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                              name="product"
                              value=""
                            >
                              <option value="">Select Product</option>
                            </select>
                          </div>
                        </div>
                      )}

                    </div>

                    <div className="flex w-full flex-col gap-5" x-data="{ 'bulkEnabled': false }">
                      <div className="lqd-input-container relative">
                        {/* <label
                          className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label"
                          htmlFor="bulk"
                        >
                          <input
                            id="bulk"
                            className="lqd-input peer focus:ring focus:ring-secondary dark:focus:ring-foreground/10 lqd-input-switcher border-2 border-input-border [--input-rounded-multiplier:5] cursor-pointer appearance-none [background-size:1.3rem] bg-left bg-no-repeat transition-all checked:bg-right checked:bg-heading-foreground checked:border-heading-foreground dark:checked:bg-label dark:checked:border-label lqd-input-md w-12 h-6"
                            name="bulk"
                            type="checkbox"
                            checked={showGenerate}
                            onChange={(e) => setShowGenerate(e.target.checked)}
                          />

                          <span className="lqd-input-label-txt">
                            Generate Bulk Posts
                          </span>
                        </label> */}
                      </div>

                      {showGenerate && (
                        <div className="w-full flex-col gap-5 flex">
                          <div className="lqd-input-container relative w-full">
                            <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3">
                              <span className="lqd-input-label-txt">
                                Number of Results
                              </span>
                            </label>

                            <input
                              id="number_of_results"
                              min="1"
                              className="lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                              name="number_of_results"
                              value="1"
                              type="number"
                              placeholder="Number of results"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="lqd-input-container relative w-full">
                      <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3">
                        <span className="lqd-input-label-txt">
                          Title
                        </span>
                      </label>

                      <input
                        id="title"
                        className="lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                        name="company_name"
                        value={content1}
                        onChange={(e) => setContent1(e.target.value)}
                        type="text"
                        required
                      />
                    </div>

                    <div className="lqd-input-container relative w-full md:w-[48%]">
                      <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3">
                        <span className="lqd-input-label-txt">
                          Language
                        </span>
                      </label>

                      <select
                        id="language"
                        className="cursor-pointer lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                        name="language"
                        onChange={(e) => setSelectedLang(e.target.value)}
                        value={selectedLang}
                        required
                      >
                        {languages.map((lang, i) => (
                          <option key={i} value={lang}>
                            {lang}
                          </option>
                        ))}
                        {/* <option value="ar-AE">Arabic</option>
                        <option value="az-AZ">Azerbaijani (Azerbaijan)</option>
                        <option value="cmn-CN">Chinese (Mandarin)</option>
                        <option value="hr-HR">Croatian (Croatia)</option>
                        <option value="cs-CZ">Czech (Czech Republic)</option>
                        <option value="da-DK">Danish (Denmark)</option>
                        <option value="nl-NL">Dutch (Netherlands)</option>
                        <option value="en-US" selected>English (USA)</option>
                        <option value="en-GB">English (UK)</option>
                        <option value="et-EE">Estonian (Estonia)</option>
                        <option value="fi-FI">Finnish (Finland)</option>
                        <option value="fr-FR">French (France)</option>
                        <option value="de-DE">German (Germany)</option>
                        <option value="el-GR">Greek (Greece)</option>
                        <option value="he-IL">Hebrew (Israel)</option>
                        <option value="hi-IN">Hindi (India)</option>
                        <option value="hu-HU">Hungarian (Hungary)</option>
                        <option value="is-IS">Icelandic (Iceland)</option>
                        <option value="id-ID">Indonesian (Indonesia)</option>
                        <option value="it-IT">Italian (Italy)</option>
                        <option value="ja-JP">Japanese (Japan)</option>
                        <option value="kk-KZ">Kazakh (Kazakhistan)</option>
                        <option value="ko-KR">Korean (South Korea)</option>
                        <option value="lt-LT">Lithuanian (Lithuania)</option>
                        <option value="ms-MY">Malay (Malaysia)</option>
                        <option value="mk-MK">Macedonian (North Macedonia)</option>
                        <option value="nb-NO">Norwegian (Norway)</option>
                        <option value="fa_IR">Persian</option>
                        <option value="pl-PL">Polish (Poland)</option>
                        <option value="pt-BR">Portuguese (Brazil)</option>
                        <option value="pt-PT">Portuguese (Portugal)</option>
                        <option value="ro-RO">Romanian (Romania)</option>
                        <option value="ru-RU">Russian (Russia)</option>
                        <option value="sk-SK">Slovak (Slovakia)</option>
                        <option value="sl-SI">Slovenian (Slovenia)</option>
                        <option value="es-ES">Spanish (Spain)</option>
                        <option value="es-MX">Spanish (Mexico)</option>
                        <option value="sw-KE">Swahili (Kenya)</option>
                        <option value="sv-SE">Swedish (Sweden)</option>
                        <option value="tr-TR">Turkish (Turkey)</option>
                        <option value="th-TH">Thai (Thailand)</option>
                        <option value="vi-VN">Vietnamese (Vietnam)</option>
                        <option value="uk-UA">Ukraine</option> */}
                      </select>
                    </div>

                    <div className="lqd-input-container relative w-full md:w-[48%]">
                      <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3" htmlFor="maximum_length">
                        <span className="lqd-input-label-txt">
                          Maximum Length
                        </span>
                      </label>

                      <input
                        id="maximum_length"
                        value={maximumLength}
                        max="1000"
                        min="1"
                        step="1"
                        className="lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                        name="maximum_length"
                        type="number"
                        placeholder="Maximum character length of text"
                        onChange={(e) => setMaximumLength(Number(e.target.value))}
                      />
                    </div>

                    <div className="lqd-input-container relative w-full md:w-[48%]">
                      <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3" htmlFor="creativity">
                        <span className="lqd-input-label-txt">
                          Creativity
                        </span>
                      </label>

                      <select
                        id="creativity"
                        className="cursor-pointer lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                        name="creativity"
                        value={selectedCreativity}
                        onChange={(e) => setSelectedCreativity(e.target.value)}
                        required
                      >
                        {creativityList.map((item, i) => (
                          <option key={i} value={item}>
                            {item}
                          </option>
                        ))}
                        {/* <option value="0.25">
                          Economic
                        </option>
                        <option value="0.5">
                          Average
                        </option>
                        <option value="0.75" selected>
                          Good
                        </option>
                        <option value="1">
                          Premium
                        </option> */}
                      </select>
                    </div>

                    <div className="lqd-input-container relative w-full md:w-[48%]">
                      <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3" htmlFor="tone_of_voice">
                        <span className="lqd-input-label-txt">
                          Tone of Voice
                        </span>
                      </label>

                      <select
                        id="tone_of_voice"
                        className="cursor-pointer lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                        name="tone_of_voice"
                        value={selectedTone}
                        onChange={(e) => setSelectedTone(e.target.value)}
                        required
                      >
                        {toneList.map((item, i) => (
                          <option key={i} value={item}>
                            {item}
                          </option>
                        ))}
                                    {/* <option value="Professional" selected>
                          Professional
                        </option>
                        <option value="Funny">
                          Funny
                        </option>
                        <option value="Casual">
                          Casual
                        </option>
                        <option value="Excited">
                          Excited
                        </option>
                        <option value="Witty">
                          Witty
                        </option>
                        <option value="Sarcastic">
                          Sarcastic
                        </option>
                        <option value="Feminine">
                          Feminine
                        </option>
                        <option value="Masculine">
                          Masculine
                        </option>
                        <option value="Bold">
                          Bold
                        </option>
                        <option value="Dramatic">
                          Dramatic
                        </option>
                        <option value="Grumpy">
                          Grumpy
                        </option>
                        <option value="Secretive">
                          Secretive
                        </option>
                        <option value="other">
                          other
                        </option> */}
                      </select>
                    </div>

                    <div className="lqd-input-container relative hidden w-full md:w-[48%]">
                      <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3" htmlFor="tone_of_voice_custom">
                        <span className="lqd-input-label-txt">
                          Enter custom tone
                        </span>
                      </label>

                      <input
                        id="tone_of_voice_custom"
                        className="lqd-input block peer px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-md w-12 h-6 hidden w-full md:w-[48%]"
                        name="tone_of_voice_custom"
                        value=""
                        type="text"
                        placeholder=""
                      />
                    </div>

                    <div className="lqd-input-container relative">
                      <label className="lqd-input-label flex cursor-pointer items-center gap-2 text-2xs font-medium leading-none text-label mb-3" htmlFor="chatbot_front_model">
                        <span className="lqd-input-label-txt">
                          Select model
                        </span>
                      </label>

                      <select
                        id="chatbot_front_model"
                        className="cursor-pointer lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11"
                        name="chatbot_front_model"
                        value=""
                      >
                        <option value="">
                          Default model
                        </option>
                        <option value="claude-opus-4-20250514">
                          Claude Opus 4
                        </option>
                        <option value="claude-sonnet-4-20250514">
                          Claude Sonnet 4
                        </option>
                        <option value="claude-3-sonnet-20240229">
                          Claude 3 Sonnet
                        </option>
                        <option value="claude-3-haiku-20240307">
                          Claude 3 Haiku
                        </option>
                        <option value="gpt-4">
                          GPT-4 (Most Expensive &amp; Fastest &amp; Most Capable)
                        </option>
                        <option value="gpt-4-turbo">
                          GPT-4 Turbo (Most Expensive &amp; Fastest &amp; Most Capable)
                        </option>
                        <option value="gpt-4-1106-preview">
                          GPT-4-1106 Turbo (Updated Knowleddge cutoff of April 2023, 128k)
                        </option>
                        <option value="gpt-4-0125-preview">
                          GPT-4-0125 Turbo (Updated Knowleddge cutoff of Dec 2023, 128k)
                        </option>
                        <option value="gpt-4o">
                          GPT-4o Most advanced works for Vision, multimodal flagship model that’s cheaper and faster than GPT-4 Turbo. (Updated Knowleddge cutoff of Oct 2023, 128k)
                        </option>
                        <option value="o1-mini">
                          GPT o1-mini (Updated Knowledge cutoff of Dec 2023, 128k)
                        </option>
                        <option value="o3-mini">
                          GPT o3-mini (Updated Knowledge cutoff of October 2023, 200k)
                        </option>
                        <option value="gpt-4.1-mini">
                          GPT-4.1 Mini (Jun 01, 2024 knowledge cutoff, 32k max output tokens.)
                        </option>
                        <option value="gpt-4.1-nano">
                          GPT-4.1 Nano (Jun 01, 2024 knowledge cutoff, 32k max output tokens.)
                        </option>
                        <option value="o4-mini">
                          GPT o4-mini (Jun 01, 2024 knowledge cutoff, 100k max output tokens.)
                        </option>
                        <option value="gpt-5">
                          GPT-5 (Oct 01, 2024 knowledge cutoff, 128k max output tokens.)
                        </option>
                        <option value="gpt-5-mini">
                          GPT-5 Mini (May 31, 2024 knowledge cutoff, 128k max output tokens.)
                        </option>
                        <option value="gpt-5-nano">
                          GPT-5 Nano (May 31, 2024 knowledge cutoff, 128k max output tokens.)
                        </option>
                        <option value="gpt-5-chat-latest">
                          GPT-5 Chat (Sep 30, 2024 knowledge cutoff, 128k max output tokens.)
                        </option>
                        <option value="gemini-2.5-flash-preview-05-20">
                          Gemini 2.5 Flash Preview 05-20 Adaptive thinking, cost efficiency
                        </option>
                        <option value="gemini-2.5-pro">
                          Gemini 2.5 Pro Preview Enhanced thinking and reasoning, multimodal understanding, advanced coding, and more
                        </option>
                        <option value="deepseek-chat">
                          Deepseek Chat
                        </option>
                        <option value="deepseek-reasoner">
                          Deepseek DeepSeek-R1
                        </option>
                        <option value="grok-3">
                          Grok 3
                        </option>
                        <option value="grok-4-0709">
                          Grok 4
                        </option>
                        <option value="perplexity/llama-3.1-sonar-huge-128k-online">
                          Perplexity: Llama 3.1 Sonar 405B Online
                        </option>
                        <option value="perplexity/llama-3.1-sonar-large-128k-online">
                          Perplexity: Llama 3.1 Sonar 70B Online
                        </option>
                        <option value="perplexity/llama-3.1-sonar-large-128k-chat">
                          Perplexity: Llama 3.1 Sonar 70B
                        </option>
                      </select>
                    </div>
                    <button
                      className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-lg px-5 py-3 lqd-btn-hover-none mt-3 w-full"
                      id="openai_generator_button"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <svg
                            className="animate-spin h-4 w-4 mr-2 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                            ></path>
                          </svg>
                          Please wait...
                        </>
                      ) : (
                        "Generate"
                      )}
                    </button>

                    {/* <button
                      className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-lg px-5 py-3 lqd-btn-hover-none mt-3 w-full"
                      id="openai_generator_button"
                      type="submit"
                    >
                      <span className="hidden group-[.lqd-form-submitting]:inline-flex">Please wait...</span>
                      <span className="group-[.lqd-form-submitting]:hidden">Generate</span>
                    </button> */}
                  </form >
                </div >
              </div >
            </div >

            <div id="workbook_textarea" className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-variant-none w-full [&amp;_.tox-edit-area__iframe]:!bg-transparent lg:border-s lg:ps-16">
              <div className="lqd-card-body relative only:grow lqd-card-size-none">
                <div className="lqd-generator-actions flex w-full flex-wrap items-center gap-3 text-2xs">
                  <div className="flex grow">
                    <div className="lqd-generator-action-btns flex w-full flex-wrap items-center gap-2 text-2xs">
                      <button className="inline-flex size-7 items-center justify-center rounded-sm transition-colors hover:bg-foreground/5" id="workbook_undo" title="Undo">
                        <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M9 14l-4 -4l4 -4"></path>
                          <path d="M5 10h11a4 4 0 1 1 0 8h-1"></path>
                        </svg>
                      </button>
                      <button className="inline-flex size-7 items-center justify-center rounded-sm transition-colors hover:bg-foreground/5" id="workbook_redo" title="Redo">
                        <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M15 14l4 -4l-4 -4"></path>
                          <path d="M19 10h-11a4 4 0 1 0 0 8h1"></path>
                        </svg>
                      </button>
                      <button className="inline-flex size-7 items-center justify-center rounded-sm transition-colors hover:bg-foreground/5" id="workbook_copy" title="Copy to clipboard">
                        <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z"></path>
                          <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1"></path>
                        </svg>
                      </button>
                      <div
                        className="lqd-dropdown flex relative group/dropdown [--dropdown-offset:0px]"
                        style={{ ['--dropdown-offset' as any]: '1rem' }}
                        x-data="dropdown({ triggerType: 'hover', preferredAnchor: 'start', offsetY: '1rem', teleport: true })"
                        x-bind="parent"
                        x-ref="parent"
                      >
                        <a
                          className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent text-foreground hover:underline hover:transform-none hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none lqd-btn-size-none lqd-btn-hover-none lqd-dropdown-trigger hover:translate-y-0 before:absolute before:-inset-3 before:pointer-events-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 group-[&amp;.lqd-is-active]/dropdown:before:pointer-events-auto px-2 py-1"
                          title="Download"
                          href="#"
                          onClick={() => setIsDownloadable(!isDownloadable)}
                        >
                          <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                            <path d="M7 11l5 5l5 -5"></path>
                            <path d="M12 4l0 12"></path>
                          </svg>
                        </a>

                        {isDownloadable && (
                          <div
                            className="lqd-dropdown-dropdown absolute top-full z-[1000] translate-y-1 transition before:absolute before:bottom-full before:-top-[--dropdown-offset] before:inset-x-0 [&amp;.lqd-is-active]/dropdown:opacity-100 [&amp;.lqd-is-active]/dropdown:visible [&amp;.lqd-is-active]/dropdown:translate-y-0 [&amp;.lqd-is-active]/dropdown:pointer-events-auto start-0"
                            style={{ ['--dropdown-offset' as any]: '1rem' }}
                          >
                            <div className="lqd-dropdown-dropdown-content w-44 border border-dropdown-border rounded-dropdown bg-dropdown-background text-dropdown-foreground shadow-lg shadow-black/5 overflow-hidden">
                              <button  onClick={() => {handleDownload("doc");setIsDownloadable(false);}} className="workbook_download flex w-full items-center gap-1 rounded-md p-2 font-medium hover:bg-foreground/5" data-doc-type="doc" data-doc-name="Youtube Video Description" >
                                <svg stroke-width="1.5" className="size-6" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                  <path d="M4 18h9v-12l-5 2v5l-4 2v-8l9 -4l7 2v13l-7 3z"></path>
                                </svg>
                                MS Word
                              </button>
                              <button  onClick={() => { handleDownload("html");setIsDownloadable(false);}} className="workbook_download flex w-full items-center gap-1 rounded-md p-2 text-2xs font-medium hover:bg-foreground/5" data-doc-type="html" data-doc-name="Youtube Video Description" >
                                <svg stroke-width="1.5" className="size-6" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                  <path d="M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"></path>
                                  <path d="M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"></path>
                                </svg>
                                HTML
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="justify-end" id="updateDiv">
                    <a
                      id="workbook_resave"
                      className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-sm py-1 px-2.5 lqd-btn-hover-none"
                      href="javascript:void(0)"
                    >
                      <svg stroke-width="1" className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path>
                        <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"></path>
                      </svg>
                      Save
                    </a>
                  </div> */}
                </div>
                <div className="lqd-generator-form-wrap mt-4 min-h-full w-full border-t pt-6">
                  <form className="workbook-form flex flex-col gap-4">
                    <div className="lqd-input-container relative">
                      <input
                        id="workbook_title"
                        className="lqd-input block peer w-full py-2 border bg-input-background text-input-foreground ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-md h-10 border-transparent px-0 font-serif text-2xl"
                        name=""
                        type="text"
                        placeholder="Untitled Document..."
                      />
                    </div>

                    <div className="lqd-input-container relative">
                      <textarea
                        id="default"
                        className="lqd-input block peer w-full px-4 py-2 border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-size-none tinymce border-0 font-body"
                        rows={25}
                        name=""
                        value=""
                        placeholder=""
                        style={{ display: "none" }}
                        aria-hidden="true"
                      ></textarea>
                      <div role="application" className="tox tox-tinymce tox-edit-focus" aria-disabled="false" style={{ height: "543px" }}>
                        <div className="tox-editor-container">
                          {/* <div data-alloy-vertical-dir="toptobottom" className="tox-editor-header">
                            <div role="group" className="tox-toolbar-overlord" aria-disabled="false">
                              <div role="group" className="tox-toolbar__primary">
                                <div title="" role="toolbar" data-alloy-tabstop="true" className="tox-toolbar__group">
                                  <button
                                    title="Formats"
                                    aria-label="Formats"
                                    aria-haspopup="true"
                                    type="button"
                                    unselectable="on"
                                    className="tox-tbtn tox-tbtn--select tox-tbtn--bespoke"
                                    aria-expanded="false"
                                    style={{ userSelect: 'none', width: '170px' }}
                                  >
                                    <span className="tox-tbtn__select-label">Paragraph</span>
                                    <div className="tox-tbtn__select-chevron">
                                      <svg width="10" height="10" focusable="false"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 0 1 0-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8Z" fill-rule="nonzero"></path></svg>
                                    </div>
                                  </button>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" tabIndex={-1} className="tox-toolbar__group">
                                  <button type="button" tabIndex={-1} className="tox-tbtn tox-tbtn--select" aria-disabled="false" style={{ width: '83.7344px' }}>
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg style={{ fill: 'none' }} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">
                                        <g clipPath="url(#clip0_3443_202)">
                                          <path
                                            d="M12.3125 6.55064L15.8125 9.94302M14.5 16.3038H18M7.5 18L16.6875 9.09498C16.9173 8.87223 17.0996 8.60779 17.224 8.31676C17.3484 8.02572 17.4124 7.71379 17.4124 7.39878C17.4124 7.08377 17.3484 6.77184 17.224 6.48081C17.0996 6.18977 16.9173 5.92533 16.6875 5.70259C16.4577 5.47984 16.1849 5.30315 15.8846 5.1826C15.5843 5.06205 15.2625 5 14.9375 5C14.6125 5 14.2907 5.06205 13.9904 5.1826C13.6901 5.30315 13.4173 5.47984 13.1875 5.70259L4 14.6076V18H7.5Z"
                                            stroke="#9A34CD"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_3443_202"><rect width="22" height="22" fill="white"></rect></clipPath>
                                        </defs>
                                      </svg>
                                    </span>
                                    <span className="tox-tbtn__select-label">Rewrite</span>
                                  </button>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" className="tox-toolbar__group">
                                  <button aria-haspopup="true" type="button" tabIndex={-1} unselectable="on" className="tox-tbtn tox-tbtn--select" style={{ userSelect: 'none', width: '24px' }} aria-expanded="false">
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">
                                        <path
                                          fillRule="evenodd"
                                          clip-rule="evenodd"
                                          d="M16.1681 6.15216L14.7761 6.43416V6.43616C14.1057 6.57221 13.4902 6.90274 13.0064 7.38647C12.5227 7.87021 12.1922 8.48572 12.0561 9.15617L11.7741 10.5482C11.7443 10.6852 11.6686 10.8079 11.5594 10.8958C11.4503 10.9838 11.3143 11.0318 11.1741 11.0318C11.0339 11.0318 10.8979 10.9838 10.7888 10.8958C10.6796 10.8079 10.6039 10.6852 10.5741 10.5482L10.2921 9.15617C10.1563 8.48561 9.82586 7.86997 9.34209 7.38619C8.85831 6.90241 8.24266 6.57197 7.57211 6.43616L6.18011 6.15416C6.0413 6.12574 5.91656 6.05026 5.82698 5.94048C5.7374 5.8307 5.68848 5.69336 5.68848 5.55166C5.68848 5.40997 5.7374 5.27263 5.82698 5.16285C5.91656 5.05307 6.0413 4.97759 6.18011 4.94916L7.57211 4.66716C8.24261 4.53124 8.85819 4.20076 9.34195 3.717C9.8257 3.23324 10.1562 2.61766 10.2921 1.94716L10.5741 0.555164C10.6039 0.418164 10.6796 0.295476 10.7888 0.207494C10.8979 0.119512 11.0339 0.0715332 11.1741 0.0715332C11.3143 0.0715332 11.4503 0.119512 11.5594 0.207494C11.6686 0.295476 11.7443 0.418164 11.7741 0.555164L12.0561 1.94716C12.1922 2.61761 12.5227 3.23312 13.0064 3.71686C13.4902 4.20059 14.1057 4.53112 14.7761 4.66716L16.1681 4.94716C16.3069 4.97559 16.4317 5.05107 16.5212 5.16085C16.6108 5.27063 16.6597 5.40797 16.6597 5.54966C16.6597 5.69136 16.6108 5.8287 16.5212 5.93848C16.4317 6.04826 16.3069 6.12374 16.1681 6.15216ZM5.98931 13.2052L5.61131 13.2822C5.14508 13.3767 4.71703 13.6055 4.38056 13.9418C4.04409 14.2781 3.81411 14.706 3.71931 15.1722L3.64231 15.5502C3.62171 15.6567 3.56468 15.7527 3.48102 15.8217C3.39735 15.8907 3.29227 15.9285 3.18381 15.9285C3.07534 15.9285 2.97026 15.8907 2.88659 15.8217C2.80293 15.7527 2.74591 15.6567 2.72531 15.5502L2.6483 15.1722C2.55362 14.7059 2.32368 14.2779 1.98719 13.9416C1.6507 13.6053 1.22258 13.3756 0.756305 13.2812L0.378305 13.2042C0.271814 13.1836 0.175815 13.1265 0.106785 13.0429C0.037755 12.9592 0 12.8541 0 12.7457C0 12.6372 0.037755 12.5321 0.106785 12.4485C0.175815 12.3648 0.271814 12.3078 0.378305 12.2872L0.756305 12.2102C1.22271 12.1157 1.65093 11.8858 1.98743 11.5493C2.32393 11.2128 2.5538 10.7846 2.6483 10.3182L2.72531 9.94016C2.74591 9.83367 2.80293 9.73767 2.88659 9.66864C2.97026 9.59961 3.07534 9.56186 3.18381 9.56186C3.29227 9.56186 3.39735 9.59961 3.48102 9.66864C3.56468 9.73767 3.62171 9.83367 3.64231 9.94016L3.71931 10.3182C3.81376 10.7847 4.04359 11.2131 4.38008 11.5497C4.71658 11.8864 5.14482 12.1165 5.61131 12.2112L5.98931 12.2882C6.0958 12.3088 6.1918 12.3658 6.26083 12.4495C6.32985 12.5331 6.36761 12.6382 6.36761 12.7467C6.36761 12.8551 6.32985 12.9602 6.26083 13.0439C6.1918 13.1275 6.0958 13.1846 5.98931 13.2052Z"
                                          fill="url(#paint0_linear_3314_1636)"
                                        ></path>
                                        <defs>
                                          <linearGradient id="paint0_linear_3314_1636" x1="1.03221e-07" y1="3.30635" x2="13.3702" y2="15.6959" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#82E2F4"></stop>
                                            <stop offset="0.502" stop-color="#8A8AED"></stop>
                                            <stop offset="1" stop-color="#6977DE"></stop>
                                          </linearGradient>
                                        </defs>
                                      </svg>
                                    </span>
                                    <div className="tox-tbtn__select-chevron">
                                      <svg width="10" height="10" focusable="false"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 0 1 0-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8Z" fill-rule="nonzero"></path></svg>
                                    </div>
                                  </button>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" className="tox-toolbar__group">
                                  <button aria-label="Insert/edit link" title="Insert/edit link" type="button" tabIndex={-1} className="tox-tbtn" aria-disabled="false" aria-pressed="false" style={{ width: '24px' }}>
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="24" height="24" focusable="false">
                                        <path
                                          d="M6.2 12.3a1 1 0 0 1 1.4 1.4l-2 2a2 2 0 1 0 2.6 2.8l4.8-4.8a1 1 0 0 0 0-1.4 1 1 0 1 1 1.4-1.3 2.9 2.9 0 0 1 0 4L9.6 20a3.9 3.9 0 0 1-5.5-5.5l2-2Zm11.6-.6a1 1 0 0 1-1.4-1.4l2-2a2 2 0 1 0-2.6-2.8L11 10.3a1 1 0 0 0 0 1.4A1 1 0 1 1 9.6 13a2.9 2.9 0 0 1 0-4L14.4 4a3.9 3.9 0 0 1 5.5 5.5l-2 2Z"
                                          fillRule="nonzero"
                                        ></path>
                                      </svg>
                                    </span>
                                  </button>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" tabIndex={-1} className="tox-toolbar__group">
                                  <button aria-label="Insert/edit image" title="Insert/edit image" type="button" tabIndex={-1} className="tox-tbtn" aria-disabled="false" aria-pressed="false" style={{ width: '24px' }}>
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="24" height="24" focusable="false">
                                        <path
                                          d="m5 15.7 3.3-3.2c.3-.3.7-.3 1 0L12 15l4.1-4c.3-.4.8-.4 1 0l2 1.9V5H5v10.7ZM5 18V19h3l2.8-2.9-2-2L5 17.9Zm14-3-2.5-2.4-6.4 6.5H19v-4ZM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 0 1-1-1V4c0-.6.4-1 1-1Zm6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                                          fill-rule="nonzero"
                                        ></path>
                                      </svg>
                                    </span>
                                  </button>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" tabIndex={-1} className="tox-toolbar__group">
                                  <div
                                    aria-pressed="false"
                                    aria-label="Text color"
                                    title="Text color"
                                    role="button"
                                    aria-haspopup="true"
                                    unselectable="on"
                                    className="tox-split-button"
                                    style={{ userSelect: 'none' }}
                                    aria-disabled="false"
                                    aria-expanded="false"
                                    aria-describedby="aria_5571179471701761023467547"
                                  >
                                    <span role="presentation" className="tox-tbtn" aria-disabled="false" style={{ width: '24px' }}>
                                      <span className="tox-icon tox-tbtn__icon-wrap">
                                        <svg width="24" height="24" focusable="false">
                                          <g fillRule="evenodd">
                                            <path className="tox-icon-text-color__color" d="M3 18h18v3H3z"></path>
                                            <path
                                              d="M8.7 16h-.8a.5.5 0 0 1-.5-.6l2.7-9c.1-.3.3-.4.5-.4h2.8c.2 0 .4.1.5.4l2.7 9a.5.5 0 0 1-.5.6h-.8a.5.5 0 0 1-.4-.4l-.7-2.2c0-.3-.3-.4-.5-.4h-3.4c-.2 0-.4.1-.5.4l-.7 2.2c0 .3-.2.4-.4.4Zm2.6-7.6-.6 2a.5.5 0 0 0 .5.6h1.6a.5.5 0 0 0 .5-.6l-.6-2c0-.3-.3-.4-.5-.4h-.4c-.2 0-.4.1-.5.4Z"
                                            ></path>
                                          </g>
                                        </svg>
                                      </span>
                                    </span>
                                    <span role="presentation" className="tox-tbtn tox-split-button__chevron" aria-disabled="false">
                                      <svg width="10" height="10" focusable="false"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 0 1 0-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8Z" fillRule="nonzero"></path></svg>
                                    </span>
                                    <span aria-hidden="true" style={{ display: 'none' }} id="aria_5571179471701761023467547">To open the popup, press Shift+Enter</span>
                                  </div>
                                  <div
                                    className="tox-split-button"
                                    style={{ userSelect: 'none' }}
                                  >
                                    <span role="presentation" className="tox-tbtn" aria-disabled="false" style={{ width: '24px' }}>
                                      <span className="tox-icon tox-tbtn__icon-wrap">
                                        <svg width="24" height="24" focusable="false">
                                          <g fillRule="evenodd">
                                            <path className="tox-icon-highlight-bg-color__color" d="M3 18h18v3H3z"></path>
                                            <path fillRule="nonzero" d="M7.7 16.7H3l3.3-3.3-.7-.8L10.2 8l4 4.1-4 4.2c-.2.2-.6.2-.8 0l-.6-.7-1.1 1.1zm5-7.5L11 7.4l3-2.9a2 2 0 0 1 2.6 0L18 6c.7.7.7 2 0 2.7l-2.9 2.9-1.8-1.8-.5-.6"></path>
                                          </g>
                                        </svg>
                                      </span>
                                    </span>
                                    <span role="presentation" className="tox-tbtn tox-split-button__chevron" aria-disabled="false">
                                      <svg width="10" height="10" focusable="false"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 0 1 0-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8Z" fillRule="nonzero"></path></svg>
                                    </span>
                                    <span aria-hidden="true" style={{ display: 'none' }} id="aria_2629000451711761023467548">To open the popup, press Shift+Enter</span>
                                  </div>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" className="tox-toolbar__group">
                                  <button aria-label="Bold" title="Bold" type="button" className="tox-tbtn" aria-disabled="false" aria-pressed="false" style={{ width: '24px' }}>
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="24" height="24" focusable="false">
                                        <path
                                          d="M7.8 19c-.3 0-.5 0-.6-.2l-.2-.5V5.7c0-.2 0-.4.2-.5l.6-.2h5c1.5 0 2.7.3 3.5 1 .7.6 1.1 1.4 1.1 2.5a3 3 0 0 1-.6 1.9c-.4.6-1 1-1.6 1.2.4.1.9.3 1.3.6s.8.7 1 1.2c.4.4.5 1 .5 1.6 0 1.3-.4 2.3-1.3 3-.8.7-2.1 1-3.8 1H7.8Zm5-8.3c.6 0 1.2-.1 1.6-.5.4-.3.6-.7.6-1.3 0-1.1-.8-1.7-2.3-1.7H9.3v3.5h3.4Zm.5 6c.7 0 1.3-.1 1.7-.4.4-.4.6-.9.6-1.5s-.2-1-.7-1.4c-.4-.3-1-.4-2-.4H9.4v3.8h4Z"
                                          fillRule="evenodd"
                                        ></path>
                                      </svg>
                                    </span>
                                  </button>
                                  <button aria-label="Italic" title="Italic" type="button" className="tox-tbtn" aria-disabled="false" aria-pressed="false" style={{ width: '24px' }}>
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="24" height="24" focusable="false">
                                        <path d="m16.7 4.7-.1.9h-.3c-.6 0-1 0-1.4.3-.3.3-.4.6-.5 1.1l-2.1 9.8v.6c0 .5.4.8 1.4.8h.2l-.2.8H8l.2-.8h.2c1.1 0 1.8-.5 2-1.5l2-9.8.1-.5c0-.6-.4-.8-1.4-.8h-.3l.2-.9h5.8Z" fillRule="evenodd"></path>
                                      </svg>
                                    </span>
                                  </button>
                                  <button aria-label="Underline" title="Underline" type="button" className="tox-tbtn" aria-disabled="false" aria-pressed="false" style={{ width: '24px' }}>
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="24" height="24" focusable="false">
                                        <path
                                          d="M16 5c.6 0 1 .4 1 1v5.5a4 4 0 0 1-.4 1.8l-1 1.4a5.3 5.3 0 0 1-5.5 1 5 5 0 0 1-1.6-1c-.5-.4-.8-.9-1.1-1.4a4 4 0 0 1-.4-1.8V6c0-.6.4-1 1-1s1 .4 1 1v5.5c0 .3 0 .6.2 1l.6.7a3.3 3.3 0 0 0 2.2.8 3.4 3.4 0 0 0 2.2-.8c.3-.2.4-.5.6-.8l.2-.9V6c0-.6.4-1 1-1ZM8 17h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 0 1 0-2Z"
                                          fillRule="evenodd"
                                        ></path>
                                      </svg>
                                    </span>
                                  </button>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" className="tox-toolbar__group">
                                  <div
                                    className="tox-split-button"
                                    style={{ userSelect: 'none' }}
                                  >
                                    <span role="presentation" className="tox-tbtn" aria-disabled="false" style={{ width: '24px' }}>
                                      <span className="tox-icon tox-tbtn__icon-wrap">
                                        <svg width="24" height="24" focusable="false">
                                          <path
                                            d="M11 5h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 0 1 0-2Zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 0 1 0-2Zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 0 1 0-2ZM4.5 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1Zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1Zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1Z"
                                            fillRule="evenodd"
                                          ></path>
                                        </svg>
                                      </span>
                                    </span>
                                    <span role="presentation" className="tox-tbtn tox-split-button__chevron" aria-disabled="false">
                                      <svg width="10" height="10" focusable="false"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 0 1 0-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8Z" fillRule="nonzero"></path></svg>
                                    </span>
                                    <span aria-hidden="true" style={{ display: 'none' }} id="aria_7768750241721761023467550">To open the popup, press Shift+Enter</span>
                                  </div>
                                  <div
                                    aria-pressed="false"
                                    aria-label="Numbered list"
                                    title="Numbered list"
                                    role="button"
                                    aria-haspopup="true"
                                    unselectable="on"
                                    className="tox-split-button"
                                    style={{ userSelect: 'none' }}
                                    aria-disabled="false"
                                    aria-expanded="false"
                                    aria-describedby="aria_8252218171731761023467551"
                                  >
                                    <span role="presentation" className="tox-tbtn" aria-disabled="false" style={{ width: '24px' }}>
                                      <span className="tox-icon tox-tbtn__icon-wrap">
                                        <svg width="24" height="24" focusable="false">
                                          <path
                                            d="M10 17h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 0 1 0-2Zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 0 1 0-2Zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 1 1 0-2ZM6 4v3.5c0 .3-.2.5-.5.5a.5.5 0 0 1-.5-.5V5h-.5a.5.5 0 0 1 0-1H6Zm-1 8.8.2.2h1.3c.3 0 .5.2.5.5s-.2.5-.5.5H4.9a1 1 0 0 1-.9-1V13c0-.4.3-.8.6-1l1.2-.4.2-.3a.2.2 0 0 0-.2-.2H4.5a.5.5 0 0 1-.5-.5c0-.3.2-.5.5-.5h1.6c.5 0 .9.4.9 1v.1c0 .4-.3.8-.6 1l-1.2.4-.2.3ZM7 17v2c0 .6-.4 1-1 1H4.5a.5.5 0 0 1 0-1h1.2c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.4a.4.4 0 1 1 0-.8h1.3c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.5a.5.5 0 1 1 0-1H6c.6 0 1 .4 1 1Z"
                                            fillRule="evenodd"
                                          ></path>
                                        </svg>
                                      </span>
                                    </span>
                                    <span role="presentation" className="tox-tbtn tox-split-button__chevron" aria-disabled="false">
                                      <svg width="10" height="10" focusable="false"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 0 1 0-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8Z" fillRule="nonzero"></path></svg>
                                    </span>
                                    <span aria-hidden="true" style={{ display: 'none' }} id="aria_8252218171731761023467551">To open the popup, press Shift+Enter</span>
                                  </div>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" className="tox-toolbar__group">
                                  <button aria-label="Blockquote" title="Blockquote" type="button" className="tox-tbtn" aria-disabled="false" aria-pressed="false" style={{ width: '24px' }}>
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="24" height="24" focusable="false">
                                        <path
                                          d="M7.5 17h.9c.4 0 .7-.2.9-.6L11 13V8c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v4c0 .6.4 1 1 1h2l-1.3 2.7a1 1 0 0 0 .8 1.3Zm8 0h.9c.4 0 .7-.2.9-.6L19 13V8c0-.6-.4-1-1-1h-4a1 1 0 0 0-1 1v4c0 .6.4 1 1 1h2l-1.3 2.7a1 1 0 0 0 .8 1.3Z"
                                          fillRule="nonzero"
                                        ></path>
                                      </svg>
                                    </span>
                                  </button>
                                </div>
                                <div title="" role="toolbar" data-alloy-tabstop="true" className="tox-toolbar__group">
                                  <button aria-label="Word count" title="Word count" type="button" className="tox-tbtn" aria-disabled="false" style={{ width: '24px' }}>
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="24" height="24" focusable="false">
                                        <path
                                          d="M4 11.5h16v1H4v-1Zm4.8-6.8V10H7.7V5.8h-1v-1h2ZM11 8.3V9h2v1h-3V7.7l2-1v-.9h-2v-1h3v2.4l-2 1Zm6.3-3.4V10h-3.1V9h2.1V8h-2.1V6.8h2.1v-1h-2.1v-1h3.1ZM5.8 16.4c0-.5.2-.8.5-1 .2-.2.6-.3 1.2-.3l.8.1c.2 0 .4.2.5.3l.4.4v2.8l.2.3H8.2V18.7l-.6.3H7c-.4 0-.7 0-1-.2a1 1 0 0 1-.3-.9c0-.3 0-.6.3-.8.3-.2.7-.4 1.2-.4l.6-.2h.3v-.2l-.1-.2a.8.8 0 0 0-.5-.1 1 1 0 0 0-.4 0l-.3.4h-1Zm2.3.8h-.2l-.2.1-.4.1a1 1 0 0 0-.4.2l-.2.2.1.3.5.1h.4l.4-.4v-.6Zm2-3.4h1.2v1.7l.5-.3h.5c.5 0 .9.1 1.2.5.3.4.5.8.5 1.4 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.3.6l-.6-.1-.4-.4v.4h-1.1v-5.4Zm1.1 3.3c0 .3 0 .6.2.8a.7.7 0 0 0 1.2 0l.2-.8c0-.4 0-.6-.2-.8a.7.7 0 0 0-.6-.3l-.6.3-.2.8Zm6.1-.5c0-.2 0-.3-.2-.4a.8.8 0 0 0-.5-.2c-.3 0-.5.1-.6.3l-.2.9c0 .3 0 .6.2.8.1.2.3.3.6.3.2 0 .4 0 .5-.2l.2-.4h1.1c0 .5-.3.8-.6 1.1a2 2 0 0 1-1.3.4c-.5 0-1-.2-1.3-.6a2 2 0 0 1-.5-1.4c0-.6.1-1.1.5-1.5.3-.4.8-.5 1.4-.5.5 0 1 0 1.2.3.4.3.5.7.5 1.2h-1v-.1Z"
                                          fillRule="evenodd"
                                        ></path>
                                      </svg>
                                    </span>
                                  </button>
                                </div>
                                <div role="toolbar" data-alloy-tabstop="true" className="tox-toolbar__group">
                                  <button aria-label="More..." title="More..." aria-haspopup="true" type="button" data-alloy-tabstop="true" className="tox-tbtn" aria-expanded="false">
                                    <span className="tox-icon tox-tbtn__icon-wrap">
                                      <svg width="24" height="24" focusable="false">
                                        <path
                                          d="M6 10a2 2 0 0 0-2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2 2 2 0 0 0-2-2Zm12 0a2 2 0 0 0-2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2 2 2 0 0 0-2-2Zm-6 0a2 2 0 0 0-2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2 2 2 0 0 0-2-2Z"
                                          fill-rule="nonzero"
                                        ></path>
                                      </svg>
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="tox-anchorbar"></div>
                          </div> */}
                          <SunEditor
                            height="400px"
                            key={isLoading ? 'loading' : generatedContent || 'empty'}
                            setOptions={{
                              plugins: (plugins as any),
                              buttonList: [
                                [
                                  "undo", "redo",
                                  "font", "fontSize", "formatBlock",
                                  "paragraphStyle", "blockquote",
                                  "bold", "underline", "italic", "strike", "subscript", "superscript",
                                  "fontColor", "hiliteColor", "textStyle", "removeFormat",
                                  "outdent", "indent", "align", "horizontalRule", "list", "lineHeight",
                                  "table", "link", "image", "video", "audio",
                                  "fullScreen", "showBlocks", "codeView", "preview", "print"
                                ],
                              ],
                            }}
                            defaultValue={
                              isLoading
                                ? `<p style="color:gray; text-align:center; padding-top:150px;">Đang tạo nội dung, vui lòng đợi...</p>`
                                : generatedContent ||
                                  `<p style="color:gray; text-align:center; padding-top:150px;">Chưa có nội dung nào được tạo.</p>`
                            }
                          />
                          {/* <SunEditor
                            height="400px"
                            key={generatedContent}
                            setOptions={{
                              plugins: (plugins as any),
                              buttonList: [
                                [
                                  "undo", "redo",
                                  "font", "fontSize", "formatBlock",
                                  "paragraphStyle", "blockquote",
                                  "bold", "underline", "italic", "strike", "subscript", "superscript",
                                  "fontColor", "hiliteColor", "textStyle",
                                  "removeFormat",
                                  "outdent", "indent",
                                  "align", "horizontalRule", "list", "lineHeight",
                                  "table", "link", "image", "video", "audio",
                                  "fullScreen", "showBlocks", "codeView",
                                  "preview", "print",
                                ],
                              ],
                            }}
                            defaultValue={generatedContent}
                          /> */}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div >
        </div >

        <input id="guest_id" type="hidden" value="aHR0cHM6Ly9hcGkub3BlbmFpLmNvbS92MS9jaGF0L2NvbXBsZXRpb25z" />
        <input id="guest_event_id" type="hidden" value="NjQ=" />
        <input id="guest_look_id" type="hidden" value="ODU=" />
        <input id="guest_product_id" type="hidden" value="Mjg=" />
        <input id="_message_no" type="hidden" name="_message_no" value="210" />

        <input
          id="_prompt"
          type="hidden"
          name="_prompt"
          value='write youtube video description about Gấu mập. Maximum 1000 words. Creativity is 0.75 between 0 and 1. Language is English US. Generate 1 different youtube video descriptions. Tone of voice must be Professional
              here some rules you must follow:
                  1. Dont use double quotation ".." marks in answers.
              '
        />
      </div >
    </Layout >
  )
}

export default Openai
